// extracted by mini-css-extract-plugin
module.exports = {"button":"BackButton_button__2Ras3","icon":"BackButton_icon__a9GyS"};